<template>
  <v-card class="v-card v-sheet theme--light m-0 text-left">
    <br />
    <h3>&nbsp;Vendor Master File Upload</h3>
    <v-container>
      <v-layout class="ma-0 pa-0">
          <v-row class="ma-0 pa-0">
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="items"
                class="elevation-1"
                hover
              >
              </v-data-table>
            </v-col>
          </v-row>
      </v-layout>
    </v-container>
  </v-card>
</template>
<script>
import { securedAxiosInstance } from "@/backend/axios";

export default {
  data() {
    return {
      headers: [
        {
          title: "Vendor Name",
          align: "start",
          sortable: false,
          value: "vendor_name",
        },
        { title: "Vendor Type", value: "vendor_type" },
        { title: "Vendor Code", value: "vendor_code" },
        { title: "Vendor Address", value: "vendor_address" },
        { title: "Vendor City", value: "vendor_city" },
        { title: "Vendor State", value: "vendor_state" },
        { title: "Vendor Pin", value: "vendor_pin" },
        { title: "Vendor Email", value: "vendor_email" },
      ],
      items: [],
    };
  },
  created() {
    this.getVendors();
  },
  methods: {
    getVendors() {
      securedAxiosInstance
        .get("/admin/vendor_masters")
        .then((response) => {
          this.items = response.data.vendor_masters;
        })
        .catch((error) => this.$toast.error("Error in retrieving vendors"));
    },
  },
};
</script>
